<sm-title-bar pageTitle="{{ 'employee_salary_settings.title' | translate }}" [back]="true"  [headerCustomTemplate]="addButton">
    <ng-template #addButton>
        <div class="d-flex search-field" (click)="addSalarySetting()" *ngIf="salaryData.length == 0">
         <div class="employee_btn">
          <button mat-icon-button color="accent">
            <mat-icon class="material-icons-round" [inline]="true"
            >settings</mat-icon>
            <!-- {{ 'employee_salary_settings.btn_text' | translate }} -->
          </button>
        </div>
        </div>
      </ng-template> 
  </sm-title-bar>

       <!-- owner info -->
       <div class="service_info" *ngIf="salaryData.length > 0 && !loader">
        <div class="row">
            <div class="col-sm-12">
                <div class="serv_seingo">
                  <div class="adm_set">
                    <div>
                      <button *ngIf="salaryData.length > 0 && !loader"
                        mat-icon-button
                        [matMenuTriggerFor]="menu"
                        class="profile_button"
                        class="share">
                        <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                      </button>
                      <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="editSalary(salaryData[0])">
                          <mat-icon class="material-icons-outlined">edit</mat-icon>
                          <span class="menu_text">{{ 'employee_salary_settings.opt_edit' | translate }}</span>
                        </button>
                      </mat-menu>
                    </div>
    
                  </div>
                    <h3>{{ 'employee_salary_settings.settings_info' | translate }}</h3>
                </div>
              
            </div>
            <div class="col-sm-3">
            <div class="service_listh">
                <div class="bus_icon">
                    <mat-icon>payments</mat-icon>
                </div>
                <div class="bus_hjk">
                    <h4> Pay Type </h4>
                    <p>  {{salaryData[0].payType1 | titlecase}} </p>
                </div>
            </div>
        </div>
        <div class="col-sm-3">
            <div class="service_listh">
                <div class="bus_icon">
                    <mat-icon>payments</mat-icon>
                </div>
                <div class="bus_hjk">
                    <h4> Pay Rate </h4>
                    <p> {{salaryData[0].currency_symbol}}{{salaryData[0].payRate.toFixed(2)}} </p>
                </div>
            </div>
        </div>
        <div class="col-sm-3">
            <div class="service_listh">
                <div class="bus_icon">
                    <mat-icon>analytics</mat-icon>
                </div>
                <div class="bus_hjk">
                    <h4>  Paid On </h4>
                    <p> {{salaryData[0].paidOn1 | titlecase}} </p>
                </div>
            </div>
        </div>
        <div class="col-sm-3">
            <div class="service_listh" style="border-right: none !important;">
                <div class="bus_icon">
                    <mat-icon>payments</mat-icon>
                </div>
                <div class="bus_hjk">
                    <h4> Net Payment </h4>
                    <p> {{salaryData[0].currency_symbol}}{{salaryData[0].netPayment.toFixed(2)}} </p>
                </div>
            </div>
        </div>
        <hr class="saley_csv">
        <div class="col-sm-3">
          <div class="service_listh">
              <div class="bus_icon">
                  <mat-icon>receipt_long</mat-icon>
              </div>
              <div class="bus_hjk">
                  <h4> Other Perks  </h4>
                  <p>  {{salaryData[0].currency_symbol}}{{salaryData[0].otherPerks.toFixed(2)}}  </p>
              </div>
          </div>
      </div>
      <div class="col-sm-3">
        <div class="service_listh" >
            <div class="bus_icon">
                <mat-icon>article</mat-icon>
            </div>
            <div class="bus_hjk">
                <h4> Perks Type </h4>
                <p>  {{salaryData[0].perksType | titlecase}}  </p>
            </div>
        </div>
    </div>
    <div class="col-sm-3">
      <div class="service_listh">
          <div class="bus_icon">
              <mat-icon>subtitles</mat-icon>
          </div>
          <div class="bus_hjk">
              <h4>  Deduction  </h4>
              <p>  {{salaryData[0].currency_symbol}}{{salaryData[0].deduction.toFixed(2)}}  </p>
          </div>
      </div>
  </div>
  <div class="col-sm-3">
    <div class="service_listh" style="border-right: none !important;">
        <div class="bus_icon">
            <mat-icon>subtitles</mat-icon>
        </div>
        <div class="bus_hjk">
            <h4>   Deduction Type   </h4>
            <p>  {{salaryData[0].deductionType && salaryData[0].deductionType != 'null' ? (salaryData[0].deductionType | titlecase) : 'N/A'}}  </p>
        </div>
    </div>
</div>
        </div>
       </div>


       <!-- placeholder section start -->
       <div class="row" *ngIf="salaryData.length == 0 && !loader">
        <div class="col-sm-12" >
          <div style="padding: 20px 18px 20px 18px;
          border-radius: var(--dra-radius-x-small);transition: 0.3s;">
            <div class="top_section_order">
              <div class="row">
               <div class="nal_rrty">
                <div style="text-align:center;min-height: 500px;padding-top: 210px">
                <div class="cv_notifia">
                 <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="m510.6 456.2-61.1-291.3c-.6-3-3.7-5-6.6-4.3l-83.4 17.5V78.8c.3-13.3-11.3-24.9-24.6-24.6h-12.8V41.3c0-13.6-11-24.6-24.6-24.6H25.9c-13.6 0-24.6 11-24.6 24.6v391.9c0 13.6 11 24.6 24.6 24.6h12.7v12.8c0 13.6 11.1 24.6 24.6 24.6h271.7c4 0 7.8-1 11.3-2.8 1.2 2.1 3.6 3.2 6 2.7l154.1-32.3c3-.5 5-3.7 4.3-6.6zM42.8 65c-2.7 4.1-4.2 8.9-4.2 13.8v367.9H25.9c-7.4 0-13.4-6-13.4-13.4v-392c0-7.4 6-13.4 13.4-13.4h271.6c7.4 0 13.4 6 13.4 13.4v12.8H63.2c-8.2 0-15.8 4.1-20.4 10.9zm292.1 419.1H63.2c-7.4 0-13.4-6-13.4-13.4V78.8c-.1-7.2 6.2-13.6 13.4-13.4h271.7c7.3-.1 13.5 6.1 13.4 13.4v101.6l-56.6 11.9-3 .6c-3 .6-5 3.6-4.3 6.6l2.5 11.8-87.7 65.7c-2.5 1.8-3 5.4-1.2 7.9l144.8 193.5.5 2.6c-2.3 1.9-5.3 3.1-8.4 3.1zm-90-211.1c6.8 8.7 4.9 22.2-4.1 28.7-2.5 1.8-3 5.5-1.1 7.9l94.2 125.9 3.5 16.9-127-169.7 79-59.1 1.7 7.9-45.1 33.6c-2.4 1.8-2.9 5.5-1.1 7.9zm6.8 33.9c8.9-9.2 11.1-24.5 5.1-35.8l36.8-27.5 34.8 165.9zM355.4 483c-11.7-56-46.9-223.3-58.8-280.3 34-7.1 108.7-22.8 143.2-30.1L498.5 453zm78.5-274.9c-11.1 2.3-21.9-4.8-24.3-15.9-.6-3-3.6-5-6.6-4.3l-66.7 14c-3 .6-5 3.6-4.3 6.6 2.3 11.1-4.8 22-15.9 24.3-3 .6-5 3.6-4.3 6.6l42.8 203.9c.6 3 3.6 5 6.6 4.3 11.1-2.3 21.9 4.8 24.2 15.8.6 3 3.7 5 6.6 4.4l66.8-14c3-.6 5-3.7 4.3-6.6-2.3-11 4.8-21.9 15.8-24.3 3-.6 5-3.6 4.3-6.6l-42.8-203.9c-.4-3-3.5-5-6.5-4.3zm37.4 205.5c-12.2 5-20.2 17.1-19.8 30.3l-56.8 11.9c-4.9-12.2-17.1-20.2-30.3-19.8l-40.7-193.9c12.2-5 20.2-17.1 19.8-30.3l56.7-11.9c5 12.3 17.3 20.2 30.3 19.8zm-81.9-124.9c-21.6 4.5-35.5 25.8-31 47.4 6.7 34.6 54.4 43.2 72.7 13.7 19.6-29.1-7.5-68.9-41.7-61.1zm14.1 67.4c-15.6 3.3-30.9-6.7-34.1-22.3-5.6-24.5 23.2-44.2 44-30 21.2 13.1 14.7 47.7-9.9 52.3zM75.7 176.6l10.9 1.1c.4 1.1.9 2.2 1.4 3.4l-7 8.5c-2.8 3.6-2.6 8.8.7 12.2L94.9 215c3.3 3.4 8.7 3.7 12.3.7l8.5-6.9c1.1.5 2.2 1 3.4 1.4l1.1 10.9c.5 4.7 4.4 8.2 9.1 8.2h18.6c4.7 0 8.6-3.5 9.1-8.2l1.1-10.9c1.2-.4 2.3-.9 3.4-1.4l8.5 6.9c3.6 3 8.9 2.8 12.3-.6l13.3-13.3c3.3-3.4 3.5-8.6.6-12.2l-6.9-8.5c.5-1.1 1-2.3 1.4-3.4l10.8-1.1c4.7-.4 8.3-4.4 8.3-9.1v-18.7c0-4.7-3.5-8.6-8.2-9.1l-10.9-1.1c-.4-1.1-.9-2.3-1.4-3.4l6.9-8.4c3-3.6 2.7-9-.6-12.3l-13.2-13.2c-3.4-3.4-8.6-3.6-12.2-.6l-8.5 6.9c-1.1-.5-2.2-1-3.4-1.4L157 95.3c-.5-4.6-4.4-8.1-9.1-8.1h-18.6c-4.7 0-8.6 3.5-9.1 8.2l-1.1 10.9c-1.1.4-2.3.9-3.4 1.4l-8.4-6.8c-3.6-3-9.1-2.7-12.3.6l-13.2 13.2c-3.3 3.3-3.6 8.5-.6 12.2l6.9 8.5c-.5 1.1-1 2.2-1.4 3.4l-10.9 1.1c-4.7.5-8.2 4.4-8.2 9.1v18.7c-.1 4.5 3.6 8.5 8.1 8.9zm3-25.9 12.6-1.3c2.3-.2 4.2-1.8 4.8-4 .7-4.9 6.5-9.8 2.8-14.5l-8-9.8 10.6-10.5 9.8 8c4.7 3.6 9.6-2.1 14.5-2.8 2.2-.6 3.8-2.5 4-4.8l1.3-12.6H146l1.3 12.6c.2 2.3 1.8 4.2 4 4.8 4.9.7 9.7 6.4 14.5 2.8l9.9-8 10.5 10.5-8 9.8c-3.6 4.8 2.1 9.6 2.9 14.5.7 2.2 2.5 3.7 4.8 3.9l12.6 1.3v14.9l-12.6 1.3c-4.9.4-5.1 6-6.9 9.5-1.5 2.8-3.2 6.2-.8 9l8 9.8-10.5 10.5-9.9-8c-4.8-3.6-9.5 2.1-14.5 2.9-2.1.7-3.7 2.5-3.9 4.8L146 218h-14.9l-1.3-12.6c-.2-2.2-1.8-4.1-3.9-4.8-5-.8-9.8-6.5-14.5-2.9l-9.8 8L91 195.2l8-9.8c2.4-2.7.8-6.2-.7-8.9-2-3.8-1.9-9.1-6.9-9.7l-12.6-1.3v-14.8zm59.8 40.4c43.6-1.3 43.6-64.5 0-65.9-43.5 1.4-43.4 64.6 0 65.9zm0-54.6c19.8-.4 29.4 25.5 14.3 38.2-13.2 12.3-36.6 1.6-36-16.4.1-12.1 9.8-21.8 21.7-21.8zm4.6 138.9h-70c-7.4 0-7.3-11.2 0-11.2h70c7.4 0 7.3 11.2 0 11.2zm0 30.7c7.4 0 7.3 11.2 0 11.2h-70c-7.4 0-7.3-11.2 0-11.2zm-75.6 47.6c0-3.1 2.5-5.6 5.6-5.6H213c3.1 0 5.6 2.5 5.6 5.6s-2.5 5.6-5.6 5.6H73.1c-3.1 0-5.6-2.5-5.6-5.6zm182.3 41.9c0 3.1-2.5 5.6-5.6 5.6H73.1c-3.1 0-5.6-2.5-5.6-5.6s2.5-5.6 5.6-5.6h171.1c3.1 0 5.6 2.5 5.6 5.6zm-5.6 47.5H73.1c-7.4 0-7.3-11.2 0-11.2h171.1c7.4 0 7.3 11.2 0 11.2z" fill="#6b6b6b" opacity="1" data-original="#000000" class=""></path></g></svg>
                </div>
                <div>
                  <p style="margin-top: 18px; color: #a8a8a8; font-size: 17px;  line-height: 24px;">
                    No salary configuration added yet. Configure base salary, allowances, deductions, payment type and payment cycle.
                 </p>
               </div>
                </div>
              </div>
             </div>
            </div>
          </div>
        </div>
      </div>
<!-- placeholder section end -->

<!-- end -->